import {createTheme, PaletteColorOptions} from "@mui/material";

declare module '@mui/material/styles' {
    interface Palette {
        brAccent: PaletteColorOptions;
        brDark: PaletteColorOptions;
        brLight: PaletteColorOptions;
        brGrey: PaletteColorOptions;
        brWhite: PaletteColorOptions;
        transparent: PaletteColorOptions;
    }
    interface PaletteOptions {
        brAccent: PaletteColorOptions;
        brDark: PaletteColorOptions;
        brLight: PaletteColorOptions;
        brGrey: PaletteColorOptions;
        brWhite: PaletteColorOptions;
        transparent: PaletteColorOptions;
    }
}

const customTheme = createTheme({
    typography: {
        fontFamily: 'Nunito Sans',
        h2: {
            fontFamily: 'Angkor',
            fontSize: '2.3rem'
        },
        h4: {
            fontFamily: 'Angkor',
            fontSize: '1.6rem'
        },
        h5: {
            fontFamily: 'Angkor',
            fontSize: '1.1rem',
            textTransform: 'uppercase'
        },
        body2: {
            fontSize: '.8rem'
        }
    },
    palette: {
        primary: {
            main: '#971916',
            light: '#C41F1C',
            dark: '#7D1412',
            contrastText: '#ffffff'
        },
        secondary: {
            main: '#114B5F',
            light: '#186E8B',
            dark: '#0C3745',
            contrastText: '#ffffff'
        },
        brAccent: {
            main: '#FCAA67',
            light: '#FDC79B',
            dark: '#FB9A4B',
            contrastText: '#000000'
        },
        brDark: {
            main: '#130303',
            light: '#350808',
            dark: '#000000',
            contrastText: '#ffffff'
        },
        brLight: {
            main: '#FFF4EB',
            light: '#ffffff',
            dark: '#FFDDC2',
            contrastText: '#000000'
        },
        brGrey: {
            main: '#666666',
            light: '#888888',
            dark: '#444444',
            contrastText: '#ffffff'
        },
        brWhite: {
            main: '#FFFFFF',
            light: '#FFFFFF',
            dark: '#EFEFEF',
            contrastText: '#EE4740'
        },
        transparent: {
            main: '#ffffff00',
            light: '#ffffff10',
            dark: '#ffffff20',
            contrastText: '#333333'
        }
    }
})

export default customTheme;